<template>
  <div class="Visual container-fluid">
    <div class="row">
      <div class="col-3 test">
        <div class="row">
          <div >
            <button :class="{btn_visuals:true, selected: showAnimationBTN}" v-on:click="toggleAnimationBtn" >Animation</button>
          </div>
        </div>
        <div class="row">
          <div class="col">
          <button :class="{btn_visuals:true, selected: showComicBTN}" v-on:click="toggleComicBtn">Comic</button>
            <transition name="comicTransition">
              <div class="comicElement" v-show="showComic">
                  <button :class="{btn_gameComic:true, selectedCOMIC: showGameComic}" v-on:click="toggleNameComics('GameComic')">Game Comic</button><br>
                  <button :class="{btn_laissemoisortir:true, selectedCOMIC: showLaisseMoiSortir}" v-on:click="toggleNameComics('LaisseMoiSortir')">Laisse-Moi <br>Sortir</button>
                  <button :class="{btn_leDelit:true, selectedCOMIC: showLeDelit}" v-on:click="toggleNameComics('leDelit')">Le Délit</button>
              </div>
            </transition>
          </div>
        </div>

      </div>
      <div class="col-9 mainBar">
        <div v-if="showComic">
          <AllComics v-bind:selected-comic="selected"></AllComics>
        </div> 
        <div v-if="showAnimation">

          <Animation></Animation>
        </div>

        <!-- default content when nothing is selected -->
        
        <div class="defaultText" v-if="(showComic == false && showAnimation == false)">
           &#60;-- Please select an option. 
        </div>
      </div>
    
    </div>
  </div>
</template>

<script>
import AllComics from './Visual/AllComics'
import Animation from './Visual/Animation'

export default {
  name: 'Visual',
  data: () => ({
    name: '',
    selected: 'GameComic',
    showComic:false,
    showAnimation:true,
    showComicBTN:false,
    showAnimationBTN:true,
    showLeDelit:false,
    showGameComic:true,
    showLaisseMoiSortir:false
  }),
  components:{
    'Animation':Animation,
    'AllComics': AllComics
  },
  methods:{
    toggleNameComics: function(name){
      this.selected = name

      if(name == "GameComic"){
        this.showGameComic = true
        this.showLaisseMoiSortir = false
        this.showLeDelit = false
      }else if(name == "LaisseMoiSortir"){
        this.showGameComic = false
        this.showLaisseMoiSortir = true
        this.showLeDelit = false
      }else if(name == "leDelit"){
        this.showGameComic = false
        this.showLaisseMoiSortir = false
        this.showLeDelit = true
      }
    },
    toggleComicBtn: function(){
      this.showComic = !this.showComic

      if(this.showAnimation){
        this.showAnimation = !this.showAnimation
      }

      // check if both are deselected, if yes than reset
      if(this.showAnimation == this.showComic){
        this.showComic = !this.showComic
      }else{
        // CSS
        this.showComicBTN = !this.showComicBTN

        if(this.showAnimationBTN == true){
          this.showAnimationBTN = false
        }
      }
    },
    toggleAnimationBtn: function(){
      this.showAnimation = !this.showAnimation

      if(this.showComic){
        this.showComic = !this.showComic
      }
      
      // check if both are deselected, if yes than reset
      if(this.showAnimation == this.showComic){
        this.showComic = !this.showComic
      }else{
        //CSS
        this.showAnimationBTN = !this.showAnimationBTN

        if(this.showComicBTN == true){
          this.showComicBTN = false
        }
      }
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

@import url('https://fonts.googleapis.com/css2?family=Cabin+Sketch&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Vibur&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Mansalva&display=swap');

@import url('https://fonts.googleapis.com/css2?family=Beth+Ellen&display=swap');


@import url('https://fonts.googleapis.com/css2?family=Meddon&display=swap');

.title{
    text-align:center;
}
.comicElement{
  z-index: -2;
}
.animationElement{
  animation: push-down 0.5s;
}
.defaultText{
  margin: 10% 20% 0 20%;
  font-family: 'Roboto', sans-serif;
  font-weight: 550;
}
@keyframes push-down{
  0%{
    opacity: 0;
    transform: translateY(-60px);
  }
  100%{
    opacity: 1;
    transform: translateY(0px);
  }
}

.comicTransition-enter-active{
  transition: opacity .5s;
  animation: slide-in .5s ;
}

@keyframes slide-in{
  0%{
    transform: translateY(-100px);
  }
  100%{
    transform: translateY(0);
  }
}
@keyframes slide-out{
  0%{
    transform: translateY(0px);
  }
  100%{
    transform: translateY(-80px);
  }
}

.comicTransition-enter, .comicTransition-leave-to{
  opacity: 0;
}

.test{
  text-align: center;
  padding-top: 2%;
}
.btn_visuals{
  font-family: 'Cabin Sketch', cursive;
  font-size: 38px;
  border: none;
  outline: none;
  border-radius: 5px;
  box-shadow: 0px 2px 2px #999;
  margin: 5%;
}


.btn_visuals:hover{
  transform: scale(1.05);
}

.btn_visuals:active{
  transform: translateY(4px);
  background-color: rgb(0, 0, 0);
  color:white;
}
.selected{

  background-color: rgb(0, 0, 0);
  color:white;
}

.btn_gameComic{
  font-family: 'Vibur', cursive;
  margin:20px 20px 0px 20px;
  border: none;
  color: rgb(255, 255, 255);
  background-color: black;
  padding: 5px 10px;
  text-align: center;
  font-size: 20px;
  cursor: pointer;
  outline: none;
  border-radius: 5px;
  box-shadow: 0px 2px 2px rgb(214, 213, 213);
}

.btn_gameComic:hover {
  transform: scale(1.05);
}


.btn_comics:active{
    transform: scale(1.05);
  background-color: rgb(0, 0, 0);
  color:white;
}

.btn_laissemoisortir{
  font-family: 'Beth Ellen', cursive;
  margin:20px 20px 0px 20px ;
  border: none;
  color: rgb(255, 255, 255);
  background-color: black;
  padding: 5px 10px;
  text-align: center;
  font-size: 16px;
  cursor: pointer;
  outline: none;
  border-radius: 5px;
  box-shadow: 0px 2px 2px rgb(214, 213, 213);
}

.btn_laissemoisortir:hover{
  transform: scale(1.05);
}
.btn_laissemoisortir:active{
  transform: translateY(4px);
  background-color: rgb(0, 0, 0);
  color:white;
}


.btn_leDelit{
  font-family: 'Meddon', cursive;
  margin:20px 20px 0px 20px ;
  border: none;
  color: rgb(255, 255, 255);
  background-color: black;
  padding: 5px 10px;
  text-align: center;
  font-size: 16px;
  cursor: pointer;
  outline: none;
  border-radius: 5px;
  box-shadow: 0px 2px 2px rgb(214, 213, 213);
}
.btn_leDelit:hover{
  transform: scale(1.05);
}
.btn_leDelit:active{
  transform: translateY(4px);
  background-color: rgb(0, 0, 0);
  color:white;
}
.selected{
  background-color: rgb(0, 0, 0);
}
.selectedCOMIC{
  background-color: rgb(241, 0, 0);
}
.defaultText{
  margin:10%;
}

</style>
